<template>
  <nav aria-label="You are here:" role="navigation">
    <ul class="breadcrumbs">
      <li
        :class="{'onviewportnotranslate': showBread}" 
        v-for="crumb in breadcrumb"
        :key="crumb.ID">
        <a v-if="crumb.href != null"
           :href="crumb.href">
          {{crumb.text}}  
        </a>
        <router-link
            :to="`${crumb.route.to}`"
            v-if="crumb.route != null">
          {{crumb.text}}
        </router-link>
      </li>
    </ul>
  </nav>  
</template>

<script>
export default {
  props:["breadcrumb"],
  data(){
    return {
      showBread: false
    }
  },
  mounted(){
    this.showBread = true;
  }
}
</script>

<style scoped>
nav{
  display: block;
}

.breadcrumbs {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    white-space: nowrap;
}

.breadcrumbs li {
    font-size: 15px;
    font-family: Montserrat;
    text-transform: none;
}

.onviewportnotranslate {
    opacity: 1 !important;
    transition-property: opacity, transform;
    transition-duration: .8s, 1s;
    transition-timing-function: ease-in, ease-in;
    transition-delay: 0.2s, 0.2s;
}

li{
    opacity: 0;
}

li{
    transition-delay: .2s;
}

li+li{
    transition-delay: .4s;
}

li+li+li{
    transition-delay: .6s;
}

li+li+li+li{
    transition-delay: .8s;
}
li+li+li+li+li{
    transition-delay: 1s;
}

[v-cloak] {
    display: none;
}

.breadcrumbs a {
  color: #a7a5a5;
}

.breadcrumbs a:hover{
  color: #c9c7c7;
}

@media (min-width : 768px) and (max-width : 1024px){
    .breadcrumbs li {
        font-size: 14px;
    }
}

@media (max-width : 767px){
  nav{
    display: none;
  }
}
</style>